import { LocaleHome } from '../en/home'

const home: LocaleHome = {
  freePlayers: '對所有選手免費',
  ourPhilosophy: '我們的理念',
  innovateGame: '創新遊戲',
  unifySport: '統一運動',
  theMostAccurateGlobal: '最準確的全球評級系統，受到世界頂級匹克球俱樂部、巡迴賽和專業人士的信賴',
  optimizedAccuracy: '優化準確性',
  yourDUPRRating: '您的DUPR評分計算管道如下',
  marginVictory: '獲勝方的分數額',
  pointsWon: '（贏得的分數）',
  typeResult: '結果類型',
  recreationalEtc: '（娛樂比賽與聯賽、正式官方比賽等。）',
  outcome: '結果',
  winLoss: '（贏或輸）',
  builtPickleball: '專為匹克球社區打造',
  builtPickleballDesc:
    '一個具有前瞻性思維和包容性的運動團體應該結合一個與之匹配的評級系統。 有了DUPR，所有的選手，不管他們的年齡，性別，地理位置，或技能，都在2.00-8.00之間的同一尺度上被評分',
  whatWeDo: '我們做什麼',
  aNewWayPlay: '一種新的玩法',
  aNewWayPlayDesc: 'DUPR評級系統不會遺失任何資訊或數據。 他們把一切都融入到他們的算灋中，使它成為最精確的平臺',
  searchTheDatabase: '蒐索資料庫',
  searchTheDatabaseDesc: '瀏覽超過1000000名匹克球選手的DUPR資料庫。',
  findYourClub: '找到您的俱樂部',
  findYourClubDesc: '關注您的俱樂部，瞭解最新的賽事資訊',
  analyzePerformance: '分析您的表現',
  analyzePerformanceDesc: 'DUPR在分析您的比賽表現來跟踪您的進展',
  logMatches: '比賽日誌',
  logMatchesDesc: '隨時輸入每場比賽的分數。',
  connectLocalPlayers: '聯系當地選手',
  connectLocalPlayersDesc: '找到本地選手並安排賽事',
  events: '活動',
  eventsDesc: '在DUPR組織的賽事中，與實力相當的對手評測您的匹克球科技',
  pickleballGlobal: '匹克球最精確的全球評級系統',
  trustedByTheWorld: '深受世界頂級匹克球俱樂部、職業巡迴賽和業餘選手的信賴。',
}

export default home
